<script setup lang="ts">
	const { label = 'Jetzt anmelden' , link } = defineProps<{
		label?: string,
		link: string
	}>()

	const cover = {
		animate: { x: '-100%', backgroundColor: '#009FE3' }
	}
	const logo = {
		animate: { x: '0%' }
	}
	const arrow = {
		animate: { scale: 1.25 }
	}
</script>

<template>
	<Motion
		as="a" :href="link" target="_blank" class="relative w-43.75 h-10 text-center overflow-hidden"
		whileHover="animate"
		whilePress="animate"
	>
		<Motion
			as="span"
			class="block w-full h-full px-3.5 py-2 text-white whitespace-nowrap font-bold text-[1.25rem] leading-tight absolute left-0 top-0"
			:initial="{
				x: '0%',
			 	backgroundColor: '#000071'
			}"
			:transition="{
				duration: 0.3,
			 	ease: 'easeInOut'
			}"
			:variants="cover"
		>
			{{ label }}
		</Motion>
		<Motion
			as="span"
			class="flex flex-row justify-end w-full h-full border border-red bg-white px-3.5 py-1 leading-tight absolute left-0 top-0"
			:initial="{ x: '-100%' }"
			:transition="{
				duration: 0.25,
			 	ease: 'easeInOut'
			}"
			:variants="logo"
		>
			<Motion
				as="span"
				class="absolute left-0 top-0 w-10 aspect-square rotate-45 -translate-x-1/2 -translate-y-px bg-red"
				:initial="{ scale: 0.5 }"
				:transition="{
					duration: 0.5,
					ease: 'easeInOut'
				}"
				:variants="arrow"
			>
			</Motion>
			<img v-lazy-load  data-src="@/assets/img/davengo-logo.webp" alt="davengo" class="mt-1" />
		</Motion>
	</Motion>
</template>
